import type { ZodRawShape } from "zod";

import type { FormDefinition, FormMutator, UseFormOptions } from "../types.js";
import { useFormSubmission } from "./useFormSubmission.js";

/**
 * Gets a mutator for the form submission for the built-in forms.
 *
 * @param formDefinition The form definition.
 * @returns The form mutator.
 */
export const usePluginFormSubmission = <T extends ZodRawShape>(
	formDefinition: FormDefinition<T>,
): FormMutator<T> => {
	const headersAndEndpointURL = getHeadersAndEndpointURL("form_submission");
	return useFormSubmission<T>(formDefinition, headersAndEndpointURL);
};

/**
 * Get the headers and endpoint URL for the REST requests.
 *
 * @param endpointName The name of the endpoint. This is the last part of the
 *   URL.
 * @returns The request headers and endpoint URL for making requests.
 */
export function getHeadersAndEndpointURL(
	endpointName: string,
): Pick<UseFormOptions, "endpoint" | "headers"> {
	const nonce = formbridge_Form_Bridge_Contact_Request_ajax_obj.payload.nonce;
	const endpoint = `/wp-json/RTFormBridge/v1/${endpointName}`;
	return {
		endpoint,
		headers: { "X-WP-Nonce": nonce, "Content-Type": "application/json" },
	};
}
